/* Chewzzle custom scripts
   (Selected-option labels are handled server-side in
   snippets/product-variant-picker.liquid.) */

/* ------------------------------------------------------------------
   Paw-print scroll trail
   A column of paw prints on the left edge that "walk" down the page
   as the visitor scrolls. Desktop only, and disabled automatically
   for anyone who prefers reduced motion.
   ------------------------------------------------------------------ */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  // Only on product pages that use the Chewzzle sections
  if (!document.querySelector('.chz-fit-cards, .chz-icon-grid')) return;

  var PAW_COUNT = 9;
  var PAW_SVG =
    '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
    '<ellipse cx="32" cy="42" rx="15" ry="12"/>' +
    '<ellipse cx="14" cy="27" rx="6.5" ry="8.5"/>' +
    '<ellipse cx="26" cy="18" rx="6" ry="8"/>' +
    '<ellipse cx="40" cy="18" rx="6" ry="8"/>' +
    '<ellipse cx="51" cy="27" rx="6.5" ry="8.5"/>' +
    '</svg>';

  var rail = document.createElement('div');
  rail.className = 'chz-paw-rail';
  rail.setAttribute('aria-hidden', 'true');

  for (var i = 0; i < PAW_COUNT; i++) {
    var paw = document.createElement('span');
    paw.className = 'chz-paw';
    // Alternate left/right so it reads like a walking trail
    paw.classList.add(i % 2 === 0 ? 'chz-paw--left' : 'chz-paw--right');
    paw.innerHTML = PAW_SVG;
    rail.appendChild(paw);
  }
  document.body.appendChild(rail);

  var paws = rail.querySelectorAll('.chz-paw');
  var ticking = false;

  function update() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    var progress = scrollable > 0 ? window.scrollY / scrollable : 0;
    var active = Math.round(progress * PAW_COUNT);
    for (var i = 0; i < paws.length; i++) {
      paws[i].classList.toggle('is-active', i < active);
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
